import { render, staticRenderFns } from "./ScoreRunCard.vue?vue&type=template&id=b5f96c20&scoped=true&"
import script from "./ScoreRunCard.vue?vue&type=script&lang=js&"
export * from "./ScoreRunCard.vue?vue&type=script&lang=js&"
import style0 from "./ScoreRunCard.vue?vue&type=style&index=0&id=b5f96c20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f96c20",
  null
  
)

export default component.exports